import { render, staticRenderFns } from "./USPS.vue?vue&type=template&id=3196c82f&"
import script from "./USPS.vue?vue&type=script&lang=js&"
export * from "./USPS.vue?vue&type=script&lang=js&"
import style0 from "./USPS.vue?vue&type=style&index=0&id=3196c82f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports